var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.show)?_c('h1',{staticClass:"landing_text"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }